import React from 'react'

const ShimmerLoader = () => {
  return (
    <div className="max-w-md">
      {/* Morning Section */}
      <div className="flex items-center gap-2 mb-4">
        <div className="h-5 w-5 bg-gray-200 rounded-full animate-pulse" />
        <div className="h-4 w-30 bg-gray-200 rounded-full animate-pulse" />
      </div>

      {/* Time Slots Grid */}
      <div className="grid grid-cols-2 gap-4">
        {[1, 2, 3, 4, 5, 6].map((index) => (
          <div
            key={index}
            className="h-10 bg-gray-200 rounded-full animate-pulse"
          />
        ))}
      </div>
    </div>
  )
}

export default ShimmerLoader
